import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../redux/cartslice';
import Context from '../../Context/Context';
import { useNavigate } from 'react-router-dom';
import ECommerceCarousel from './Carousel';
import { toast } from 'react-toastify';
import Loader from '../../ApiCheck/Loader';
import { baseUrl } from '../../ApiCheck/Constant';

const Home = () => {
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const [loading, setLoading] = useState(false);

  const user = useSelector((state) => state.user);
  const { fetchCartCount } = useContext(Context);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if(user.user.role === 'ADMIN') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/api/product`);
      setFilteredProducts(response.data.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch product. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    
    fetchProducts();
    fetchCartCount();
  }, []);

 

  const addToCartHandler = async (product) => {
    if (user.isAuth) {
      setLoading(true);
      try {
        dispatch(addToCart(product));
        const payload = { ...product, quantity: 1 };
        await axios.post(`${baseUrl}/api/addtocart`, payload);
        toast.success("Product added to cart", { position: 'top-center', autoClose: 3000 });
        fetchCartCount();
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to added product from cart. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please Login...", { position: 'top-center', autoClose: 3000 });
    }
  };

  const showProductDetails = (product) => {
    if (user.isAuth) {
      navigate(`/product/${product._id}`, { state: { product } });
    } else {
      toast.error("Please Login...", { position: 'top-center', autoClose: 3000 });
    }
  };

  const handleViewMore = () => {
    navigate('/product');
  };

  const style = {
    width: "50%",          
    height: "100%",       
    margin: "auto",
    cursor: 'pointer'
  };

  return (
    <div className="container mt-2">
      <ECommerceCarousel />

      {loading ? (
        <Loader />
      ) : (
        <>
          <h1 className="mt-3">All Products</h1>
          {filteredProducts.length > 0 ? (
            <div className="row mt-3">
              {filteredProducts.slice(0, visibleCount).map((product, index) => (
                <div className="col-md-4 col-sm-6 mb-3 p-2" key={index}>
                  <div className="card h-100 shadow-sm border-0">
                    <img
                      src={product.image}
                      className="card-img-top fixed-image"
                      style={style}
                      alt="Product"
                      onClick={() => showProductDetails(product)}
                    />
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title text-truncate" onClick={() => showProductDetails(product)}>{product.name}</h5>
                      <p className="card-text text-truncate">{product.description}</p>
                      <div className="mt-auto d-flex justify-content-between align-items-center">
                        <span className="fw-bold text-primary">₹{product.price}</span>
                        <button type="button" className="btn btn-dark btn-sm" onClick={() => addToCartHandler(product)}>
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-3">
              <p>No products found.</p>
            </div>
          )}

          <div className="text-center">
            <button className="btn btn-dark m-3" onClick={handleViewMore}>
              View More
            </button>
          </div>
          
        </>
      )}
    </div>
  );
};

export default Home;
